import MobFull from '@rebuild/materials/shared/summary/mobile/FullIndex.vue';
import Overview from './overview.vue';

export const componentMap = {
	overview: Overview,
	'mob-full': MobFull
};